<template>
    <div>
        <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center"
                     style="min-height: 600px; background-image: url(img/theme/profile-cover.jpg); background-size: cover; background-position: center top;">
            <!-- Mask -->
            <span class="mask bg-gradient-success opacity-8"></span>
            <!-- Header container -->
           
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row justify-content-center">
                <div class="col-xl-8 order-xl-1">
                    <card shadow type="secondary">
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col-8">
                                    <h3 class="mb-0">My account</h3>
                                </div>
                                <div class="col-4 text-right">
                                    <base-button class="btn btn-sm btn-primary" @click="updateUser()">Cập Nhật</base-button>
                                </div>
                            </div>
                        </div>
                        <template>
                            <form @submit.prevent>
                                <h6 class="heading-small text-muted mb-4">Thông tin tài khoản</h6>
                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="Username"
                                                        placeholder="Username"
                                                        input-classes="form-control-alternative"
                                                        v-model="model.username"
                                            />
                                        </div>
                                        <div class="col-lg-6">
                                            <base-input type="password"
                                                        label="Password"
                                                        input-classes="form-control-alternative"
                                                        v-model="model.password"
                                            />
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="Full name"
                                                        placeholder="Full name"
                                                        input-classes="form-control-alternative"
                                                        v-model="model.fullname"
                                            />
                                        </div>
                                        <div class="col-lg-6">
                                            <base-input type="password"
                                                        label="Confirm"
                                                        input-classes="form-control-alternative"
                                                        v-model="model.password2"
                                                        :error="passwordcheck"
                                            />
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <i>IDC mặc định</i>
                                            <v-select :options="model.availableIDC" v-model="model.defaultIDC"></v-select>
                                        </div>
                                    </div>
                                </div>
                                <hr class="my-4" />
                                <!-- Address -->
                                <h6 class="heading-small text-muted mb-4">Thông tin liên hệ</h6>
                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <base-input alternative=""
                                                        label="Mobile"
                                                        placeholder="Mobile"
                                                        input-classes="form-control-alternative"
                                                        v-model="model.mobile"
                                            />
                                        </div>
                                        <div class="col-md-6">
                                            <base-input alternative=""
                                                        label="Email"
                                                        placeholder="Email Address"
                                                        input-classes="form-control-alternative"
                                                        v-model="model.email"
                                            />
                                        </div>
                                    </div>                                   
                                </div>
                            </form>
                        </template>
                    </card>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

  export default {
    name: 'user-profile',
    data() {
      return {
        model: {

        },
      }
    },
    mounted(){
        this.model = this.$store.state.user
    },
    methods: {

        async updateUser() {
            if (!this.passwordcheck) {
            let update = {_id: this.model._id}
            if(this.model.password != null ){
                update.password = this.model.password
            }
            if(this.model.email != null) {
                update.email = this.model.email
            }
            if(this.model.fullname != null) {
                update.fullname = this.model.fullname
            } 
            if(this.model.mobile != null) {
                update.mobile = this.model.mobile
            }
            if(this.model.defaultIDC != null) {
                update.defaultIDC = this.model.defaultIDC
            }
            await this.$http.post('/users/edit', update)
            await this.$store.dispatch('update_user',this.model)
            this.model.password = ''
            this.model.password2 = ''
            this.$notify({type:'success',message:"Update successful"})
            }
        }
    },
    computed: {
        passwordcheck () {
            if (this.model.password != this.model.password2) {
                return 'Password miss match'
            }
            return ''
        }
        
    },

  };
</script>
<style></style>
